import React, { useEffect, useState } from 'react';
import './project.css';
import { Link } from 'react-router-dom';
import API_URL from "../config/api";

const Project = () => {
  const [arboretumCount, setArboretumCount] = useState(0);
  const [treetifyCount, setTreetifyCount] = useState(0);

  const handleDownload = async (appName, apkUrl) => {
    try {
      await fetch(`${API_URL}/public/downloads/record_download.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          app_name: appName,
        }),
      });

      fetchDownloadCounts();
      
      window.location.href = apkUrl;

    } catch (err) {
      console.error(err);
    }
  };

  const fetchDownloadCounts = async () => {
      try {
          const response = await fetch(`${API_URL}/public/downloads/get_download_counts.php`
          );
          const result = await response.json();
          if(!result.success){
              throw new Error("Unable to load download counts.");
          }
          setArboretumCount(result.data.arboretum || 0);
          setTreetifyCount(result.data.treetify || 0);
      } catch(err){
          console.error(err);
      }
  };

  useEffect(() => {
    fetchDownloadCounts();
  }, []);

  return (
    <div className="pojectTitle">
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      <link
        href="https://fonts.googleapis.com/css2?family=Pacifico&display=swap"
        rel="stylesheet"
      />

      <h1 className="otherRelatedProject">Other Related Project</h1>
      <div style={styles.wrapper}>
        <div className="cardContainer" style={styles.cardContainer}>
          {/* Card 1: ARBORETUM */}
          <div className="card-1" style={styles.card}>
            <div style={styles.contentRow}>
              <img
                src="/img/ArburetumLOGO.png"
                alt="Logo"
                className="icon"
                style={styles.logo}
              />
              <div>
                <h3>AR-ARBoretum</h3>
                <p
                  className="viewMoreInfo"
                  onClick={() =>
                    handleDownload(
                      "arboretum",
                      "https://drive.google.com/file/d/1Zy9gQ5QJ7stDICILG1C2EOH0Q1dfprtz/view?usp=sharing"
                    )
                  }
                  style={styles.downloadInfo}
                >
                  Install App
                </p>
                <p style={styles.downloadInfo}>
                  Downloads: {arboretumCount}
                </p>
              </div>
            </div>

            <div className="about" style={styles.about}>
              <h5>About</h5>
              <p>
                AR-ARboretum is an innovative application designed to educate users
                about fruit trees to life through Augmented Reality (AR) using
                interactive 3D models. By addressing the lack of familiarity with
                fruit trees, ARboretum enhances learning through immersive
                digital experience.
              </p>
            </div>

            <div>
              <Link className="viewMoreInfo view12" to="/Arburetum">
                View more info
              </Link>
            </div>
          </div>

          {/* Card 2: TREETIFY */}
          <div className="card-2" style={styles.card}>
            <div style={styles.contentRow}>
              <img
                src="/img/TreetifyLOGO.png" 
                alt="Logo"
                className="icon"
                style={styles.logo}
              />
              <div>
                <h3>Treetify</h3>
                <p
                  className="viewMoreInfo"
                  style={styles.downloadButton}
                  onClick={() =>
                    handleDownload(
                      "treetify",
                      "https://drive.google.com/file/d/1Zy9gQ5QJ7stDICILG1C2EOH0Q1dfprtz/view?usp=sharing"
                    )
                  }
                >
                  Install App
                </p>
                <p style={styles.downloadInfo}>
                  Downloads: {treetifyCount}
                </p>
              </div>
            </div>

            <div className="about" style={styles.about}>
              <h5>About</h5>
              <p>
                Treetify is a mobile application designed for scanning fruit trees using
                image recognition — an intuitive and practical tool for gardeners, farmers,
                and nature enthusiasts. By taking a photo of a fruit tree, flower, fruit, leaf,
                or bark, users can identify the species and receive both scientific and common names.
              </p>
            </div>

            <div>
              <Link className="viewMoreInfo view12" to="/Treetify">
                View more info
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;

const styles = {
  wrapper: {
    width: '100%',
    minHeight: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },

  cardContainer: {
    width: '100%',
    maxWidth: '1200px',
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    flexWrap: 'wrap',
  },

  card: {
    flex: '1 1 450px',
    maxWidth: '550px',
    minWidth: '280px',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },

  contentRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    flexWrap: 'wrap',
  },

  logo: {
    width: '70px',
    height: '70px',
    objectFit: 'contain',
    borderRadius: '50%',
  },

  about: {
    marginTop: '15px',
  },

  downloadInfo: {
    marginTop: '5px',
    fontSize: '14px',
  },

  
};


